/**
 * 人脸识别
 */

import { saveOldLocation } from '../../modules/actions';

export default store => ({
  path: 'faceRecognition',
  onEnter(nextState, replace, callback) {
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const faceRecognition = require('./components/faceRecognition').default;
        cb(null, faceRecognition);
      },
      'faceRecognition'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/faceRecognition/index.js